import { isShellNavGroupActive } from '@/shared/shell/nav-active.js';
import { isShellNavGroup, type ShellNavEntry } from '@/shared/shell/nav.types.js';

export function resolveInitialOpenGroups(
  pathname: string,
  entries: readonly ShellNavEntry[],
): Record<string, boolean> {
  const openGroups: Record<string, boolean> = {};

  for (const entry of entries) {
    if (isShellNavGroup(entry) && isShellNavGroupActive(pathname, entry)) {
      openGroups[entry.id] = true;
    }
  }

  return openGroups;
}

export function resolveOpenGroupsAfterPathnameChange(input: {
  previousPathname: string;
  nextPathname: string;
  entries: readonly ShellNavEntry[];
  currentOpenGroups: Readonly<Record<string, boolean>>;
}): Record<string, boolean> {
  if (input.previousPathname === input.nextPathname) {
    return { ...input.currentOpenGroups };
  }

  const next = { ...input.currentOpenGroups };

  for (const entry of input.entries) {
    if (!isShellNavGroup(entry)) {
      continue;
    }

    const wasActive = isShellNavGroupActive(input.previousPathname, entry);
    const isActive = isShellNavGroupActive(input.nextPathname, entry);

    if (isActive && !wasActive) {
      next[entry.id] = true;
    }
  }

  return next;
}
